
export const DELETE_USER = "DELETE_USER";
export const SET_USER = "SET_USER";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const CHANGE_MEMBERSHIP = "CHANGE_MEMBERSHIP";
export const ADD_USER = "ADD_USER";
export const COURSE_UNENROLL = "COURSE_UNENROLL";
export const EDIT_USER ="EDIT_USER";